export default __webpack_public_path__ + "static/song-bg2@2x-2b79a7f4fb898b0c9a40d75c99548a97.jpg";